import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {indexNotFound, Locale} from 'sdv-common';
import {ApiService} from './service/api.service';
import {CookieService} from 'ngx-cookie-service';
import {getBrowserName, keys} from './shared/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private translate: TranslateService,
              private apiService: ApiService,
              private titleService: Title,
              private cookieService: CookieService) {
    const settings = JSON.parse(cookieService.get(keys.settings) || '{}');
    if (!settings.lang) {
      const lang = (navigator.language + '').toLowerCase();
      if (lang.indexOf('en') > indexNotFound || lang.indexOf('us') > indexNotFound) {
        settings.lang = Locale.ENGLISH.name;
      } else if (lang.indexOf('ru') > indexNotFound) {
        settings.lang = Locale.RUSSIAN.name;
      } else if (lang.indexOf('uk') > indexNotFound || lang.indexOf('ua') > indexNotFound) {
        settings.lang = Locale.UKRAINE.name;
      } else {
        settings.lang = Locale.ENGLISH.name;
      }
    }
    translate.setDefaultLang(settings.lang);
    const subscription = translate.get('app.title')
      .subscribe(title => {
        titleService.setTitle(title);
        subscription.unsubscribe();
      });

    const browserName = getBrowserName();
    setTimeout(() => {
      if (!window.matchMedia('(display-mode: standalone)').matches && browserName === 'safari') {
        document.getElementById('iosButtonInstallApp').click();
      }
    }, 3000);
  }

}
